<template>
  <div class="login-page items-center justify-center">
    <v-progress-circular
      :size="50"
      color="primary"
      indeterminate
      v-if="hasTokenInUrl"
    ></v-progress-circular>
    <v-card :loading="loading" class="mx-auto item-card" v-if="!hasTokenInUrl">
      <warnningComponent
        v-bind:textInfo.sync="textWarning"
        v-bind:typestatus.sync="typeWarning"
        v-bind:alert.sync="showWarnnig"
      ></warnningComponent>
      <div class="mb-5" :class="isNerdOf ? 'logo' : 'logo-vknows'">
        <v-img v-if="isNerdOf" src="../../assets/layout/nerdof_icon.png"></v-img>
        <v-img v-if="isVKNOWS" src="../../assets/layout/vknows_small.png"></v-img>
        <v-img v-if="isClsedo" src="../../assets/layout/clsedo.jpg"></v-img>
      </div>
      <div class="my-10">
        <v-card-title
          primary-title
          class="headline justify-center pa-0 font-weight-bold"
          >{{fromDomain}}</v-card-title
        >
        <p class="text-center">Use your Organization Account</p>
      </div>

      <!-- <v-card-text>
            <div class="text--primary">
              well meaning and kindly.
              "a benevolent smile"
            </div>
      </v-card-text>-->

      <v-form
        ref="form"
        v-model="valid"
        v-on:submit.prevent="validate"
        class="px-5 pb-8"
      >
        <div class="text-center mt-2 mb-8">
          <v-text-field
            outlined
            v-model="email"
            type="email"
            :rules="emailRules"
            placeholder="E-mail / Username"
            required
            clearable
            class="iconInput md-w-100 xs-full-width m-auto"
          ></v-text-field>

          <v-btn
            :disabled="!valid"
            :color="isVKNOWS ? '#4BD0A0' : 'primary'"
            class="md-w-100 xs-full-width white--text"
            @click="validate"
            >Next</v-btn
          >
        </div>
      </v-form>
      <!-- <div class="or-line text-center">
        <span>OR</span>
      </div>

      <v-card-text class="my-4">
        <div class="text--primary text-center">login with</div>
      </v-card-text> -->

      <!-- <v-card-text class="my-4 text-center">
        <span class="body-1">Don't have an Accout ?</span>
        <a class="body-1 text--primary font-weight-medium">Register</a>
      </v-card-text>
      <v-card-text class="w-auto md-position-bottom-0">
        <a class="text--primary">Terms & Condition</a>
      </v-card-text> -->
    </v-card>
  </div>
</template>
<script>
// import ModalFilter from '../components/ModalFilter';
import { checkCompany, loginByToken, getInfo } from "@/service/account/login";
import warnningComponent from "../../components/warningAlert.vue";
import { setMetaTag } from "../../helper/metaTag"
import { isNerdOf, isVKNOWS, isClsedo } from "../../helper/domain"

export default {
  name: "login",
  components: {
    warnningComponent,
  },
  data() {
    return {
      loading: false,
      selection: 1,
      valid: true,
      email: "",
      emailRules: [(v) => !!v || "E-mail or Username is required"],
      textWarning: "",
      typeWarning: "",
      showWarnnig: false,
      hasTokenInUrl: false
    };
  },
  async beforeMount() {
    // let status = await logout();
    //   await this.$store.commit("clear");
    //   await localStorage.clear();
    const host = window.location.host;
    const parts = host.split(".");
  

    var tokenForLogin = this.$route.query.token;
    if (tokenForLogin) {
      try {
        this.hasTokenInUrl = true;
        var result = await loginByToken({token: tokenForLogin});
        if (!result.status) {
          throw 'Cannot login by token';
        }
        await localStorage.setItem("x-session-token", result.data.result.token);
        await localStorage.setItem("expWeb", result.data.result.endTime);
        let resultInfo = await getInfo();
        if (resultInfo.info && resultInfo.info.companies && resultInfo.info.companies[0] && resultInfo.info.email && result.data.result.companies) {
          let getCompaniesResult = await checkCompany({
            username: resultInfo.info.email,
          });
          setMetaTag(resultInfo.info.companies[0])
          let currentCompany = getCompaniesResult.filter(c => {
            return c.companies[0]._id === result.data.result.company
          });
          await localStorage.setItem("company", JSON.stringify(currentCompany[0]));
          await this.$store.commit("setTheme", resultInfo.info);
          await this.$router.replace({ path: "/" });
        } else {
          throw 'Cannot login by token'
        }
      }
      catch(err) {
        this.hasTokenInUrl = false;
      }  
    }
  },
  methods: {
    async validate() {
      this.$refs.form.validate();
      this.loading = true;

      this.loginCompany();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async loginCompany() {
      let result = await checkCompany({
        username: this.email,
      });

      if (!result) {
        this.warnnig("ไม่พบผู้ใช้", "warning");
        this.loading = false;
        return;
      } else {
        this.loading = false;
      }

      if (result.length > 1) {
        await localStorage.setItem("companies", JSON.stringify(result));
        await this.$router.push({ path: "/select-company" });
      } else if (result.length == 1) {
        await localStorage.setItem("company", JSON.stringify(result[0]));
        await this.$router.push({ path: "/enter-password" });
      }
    },
    warnnig(text, type) {
      (this.textWarning = text),
        (this.typeWarning = type),
        (this.showWarnnig = true);
    },
  },
  computed: {
    isVKNOWS() {
      return isVKNOWS();
    },
    isNerdOf() {
      return isNerdOf();
    },
    isClsedo() {
      return isClsedo();
    },
    fromDomain() {
      let name = ""
      if(isVKNOWS()){
        name = "VKNOWS"
      } else if(isClsedo()){
        name = "CLSEDO"
      } else if(isNerdOf()){
        name = "Nerdof"
      }
      return name
    }
  },
};
</script>
<style scoped>
.logo {
  width: 20%;
  /* width: 180px; */
  margin: 0 auto;
}
.logo-vknows {
  /* width: 20%; */
  width: 180px;
  margin: 0 auto;
}
.login-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-card {
  /* width: 30%; */
  min-height: 300px;
  padding: 48px 0 0;
}

.md-w-100 {
  width: 90%;
}
.or-line {
  width: 74%;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
  line-height: 0.1em;
  margin: 10px auto 20px;
}
.or-line span {
  background: #fff;
  padding: 0 30px;
  color: #e0e0e0;
}
.w-auto {
  width: auto !important;
}
.m-auto {
  margin: 0 auto !important;
}
.md-position-bottom-0 {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
}
.md-position-relative {
  position: relative !important;
}

@media only screen and (max-width: 768px) {
  .or-line {
    width: 94%;
  }
  .item-card {
    width: 100%;
    /* min-height: 90%; */
    padding: 36px 0 0;
  }
  .login-page {
    height: 100%;
    align-items: unset;
  }
  .xs-position-unset {
    position: unset !important;
  }
  .xs-full-width {
    width: 90% !important;
  }
}
@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .item-card {
    width: 45%;
    min-height: 560px;
  }
  .or-line {
    width: 94%;
  }
  .login-page {
    height: 100%;
    align-items: center;
  }
  .xs-position-unset {
    position: unset !important;
  }
  .xs-full-width {
    width: 90% !important;
  }
  .md-hidden {
    display: none;
  }
}
@media only screen and (min-width: 1025px) and (max-width: 1795px) {
  .item-card {
    width: 30%;
  }
}
@media only screen and (min-width: 1796px) {
  .item-card {
    width: 25%;
  }
}
</style>
<style lang="scss">
.iconInput {
  .v-input__control > .v-input__slot > .v-input__append-inner {
    margin-left: auto !important;
    padding-left: 4px !important;
    margin-top: 6px !important;
}
}
</style>